import React from 'react';
import { Typography } from '@mui/material';

/**
 * SKIN-21 (F web render) — renders the SkincAIr app version + last-seen for
 * one researcher in the Users tab. Both inputs are optional because a
 * researcher who has only ever used the web Dashboard has no `clientMeta`
 * stamped by `recordLastSeen()` server-side.
 *
 * `lastSeenAt` is rendered as an absolute `YYYY-MM-DD HH:mm UTC` string rather
 * than a relative "5 minutes ago" — when this is photographed for support
 * (which is the kiosk reporting workflow on the device side, and the same
 * habit applies here on a manager's desk), an absolute UTC timestamp survives
 * being read hours later in any timezone without ambiguity.
 */
export function ResearcherVersionCell({
  appVersion,
  lastSeenAt,
}: {
  appVersion: string | null | undefined;
  lastSeenAt: string | null | undefined;
}) {
  const formatted = formatLastSeenUtc(lastSeenAt);
  return (
    <div>
      <Typography variant="body2">{appVersion || '—'}</Typography>
      {formatted && (
        <Typography variant="caption" color="text.secondary">
          {formatted}
        </Typography>
      )}
    </div>
  );
}

function formatLastSeenUtc(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +
    `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`
  );
}
